import _ from "lodash";
import { scroller } from "react-scroll";
import { getDestQuickInfo } from "../../api";
import {
  fetchRestaurantsList,
  fetchRestaurantCategories,
  retrieveRestaurant,
} from "../../api/restaurants";
import {
  RESTAURANT_SEARCH_LOADING,
  RESTAURANT_SEARCH_IDLE,
  RESTAURANT_SEARCH_CHANGE,
  RESTAURANT_SEARCH_UPDATE,
  RESTAURANT_SEARCH_FORM_UPDATE,
  RESTAURANT_SEARCH_RESET,
  RESTAURANT_CATEGORIES_SAVE,
  RESTAURANT_SEARCH_FORM_INIT,
} from "./types";

export const restaurantSearchFormUpdate = (form) => {
  return { type: RESTAURANT_SEARCH_FORM_UPDATE, form };
};
export const restaurantSearchFormInit = () => {
  return { type: RESTAURANT_SEARCH_FORM_INIT };
};

export const restaurantSearchLoading = () => {
  return { type: RESTAURANT_SEARCH_LOADING };
};

export const restaurantSearchIdle = () => {
  return { type: RESTAURANT_SEARCH_IDLE };
};

export const restaurantSearchChangeOneField = ({ key, value }) => {
  return { type: RESTAURANT_SEARCH_CHANGE, key, value };
};

export const updateRestaurantSearchResult = (data) => {
  return { type: RESTAURANT_SEARCH_UPDATE, data };
};

export const resetRestaurantSearchResult = () => {
  return { type: RESTAURANT_SEARCH_RESET };
};

export const restaurantCategoriesResult = (data) => {
  return { type: RESTAURANT_CATEGORIES_SAVE, data };
};

export const restaurantSearch =
  ({ newSearch = false }) =>
  async (dispatch, getState) => {
    const state = getState();

    const {
      destinationObj,
      price_quartile,
      category,
      aggregate_score,
      page,
      page_size,
      order_by,
      website_api_key,
    } = state.RestaurantSearchForm;
    const destCode = destinationObj.destination_code;
    const rid = destinationObj.restaurant_rid;

    dispatch(restaurantSearchLoading());

    var results = [];
    var restaurants = [];

    if (destCode) {
      const [lvl, id] = _.get(destCode, 0).split("___");

      var destData = [];
      destData = await getDestQuickInfo({ destinations: `${lvl}__${id}` });

      const finalSearchFields = {
        country: destData[0].code,
        lat: destData[0].geodata.lat,
        lng: destData[0].geodata.lng,
        price_quartile,
        category,
        aggregate_score,
        page: newSearch ? 1 : page,
        page_size,
        radius: 35000,
        order_by,
        website_api_key,
      };
      if (finalSearchFields.country === "GB") {
        finalSearchFields.country = "UK";
      }

      if (!destData[0]) {
        return false;
      }

      results = await fetchRestaurantsList({
        ...finalSearchFields,
      });
      restaurants = _.get(results, "results", []);
    }

    if (rid) {
      results = await retrieveRestaurant({ rid });
      if (results) {
        restaurants = [results];
      }
    }

    if (!results) {
      results = [];
    }

    var state_restaurants = _.cloneDeep(state.RestaurantSearchReducer.restaurants);
    var count = 0;
    var newPage = 1;
    var previous = null;
    var next = null;
    if (rid) {
      state_restaurants = restaurants;
      count = 1;
    } else {
      count = results.count;
      newPage = results.page;
      previous = results.previous;
      next = results.next;
      if (page === 1) {
        state_restaurants = restaurants;
      } else {
        if (results.results) {
          state_restaurants = [...state_restaurants, ...restaurants];
        } else {
          state_restaurants = [];
        }
      }
    }

    await dispatch(
      updateRestaurantSearchResult({
        restaurants: state_restaurants,
        count,
        previous,
        next,
        page: newPage,
        loading: false,
      }),
    );
    scroller.scrollTo("restaurants-list", {
      duration: 800,
      delay: 0,
      smooth: "easeInOutQuart",
      offset: -80,
    });
    return true;
  };

export const getRestaurantCategories = () => async (dispatch, getState) => {
  const state = getState();
  if (state.RestaurantCategories.categories.length) {
    return false;
  }
  try {
    const results = await fetchRestaurantCategories();
    if (!results) {
      // handle error
      return false;
    }
    dispatch(
      restaurantCategoriesResult({
        categories: results.categories.map((r) => [r, r]),
        count: results.count,
      }),
    );
    return true;
  } catch {
    return false;
  }
};
